import API_URLS from '@/api/API_URLS.js';
import { httpPost } from '@/api/request';
export const emailLogin = params => httpPost(API_URLS.EMAIL_LOGIN, params);
export const registerEmail = params => httpPost(API_URLS.EMAIL_REGISTER, params);
export const sendCaptcha = params => httpPost(API_URLS.EMAIL_CAPTCHA, params);
export const userLogout = params => httpPost(API_URLS.USER_LOGOUT, params);
export const checkToken = params => httpPost(API_URLS.CHECK_TOKEN, params);